export default {"src":"/_next/static/image/public/images/uploadRx_insturction_image.598364d7e9245a328bf304db7e9dfcaf.svg","height":390,"width":381};